export default __webpack_public_path__ + "static/media/CNo.56-4.a45a996e.jpg";